import React from "react";

const Contact = () => {
    return (
        <div className="hero contact">
            <div className="contact-modal">
                <div>
                    <h1
                        style={{
                            color: "darkblue",
                            textAlign: "center",
                            marginBottom: "10px",
                        }}
                    >
                        Contact Us
                    </h1>
                </div>
                <p>Bynry Inc. 16192 COASTAL HWY, LEWES, DE 19958</p>
                <p>+1 (732) 860-2552</p>
                <p>contact@bynry.io</p>
            </div>
        </div>
    );
};

export default Contact;
